import React from 'react';

// Header Tab Icons
export const ScopeSelectionIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M9 11l3 3L22 4' />
      <path d='M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11' />
    </svg>
  );
};

export const QuotePricingIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <line x1='12' y1='1' x2='12' y2='23' />
      <path d='M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' />
    </svg>
  );
};

export const ResetIcon = () => {
  return (
    <svg className='mr-2' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
      <path d='M3 3v5h5' />
    </svg>
  );
};

// Trade Panel Icons
export const ArrowDownIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <polyline points='18 15 12 9 6 15'></polyline>
    </svg>
  );
};

export const ArrowUpIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <polyline points='6 9 12 15 18 9'></polyline>
    </svg>
  );
};

// Scope Details Panel Icons
export const EmptyStateIcon = () => {
  return (
    <svg width='64' height='64' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' opacity='0.3'>
      <rect x='3' y='3' width='18' height='18' rx='2' ry='2' />
      <line x1='9' y1='9' x2='15' y2='9' />
      <line x1='9' y1='12' x2='15' y2='12' />
      <line x1='9' y1='15' x2='11' y2='15' />
    </svg>
  );
};

// Price Summary Panel Icons
export const ContinueArrowIcon = () => {
  return (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <polyline points='9 18 15 12 9 6'></polyline>
    </svg>
  );
};

// Pricing Breakdown Card Icons
export const AddDiscountIcon = () => {
  return (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' />
    </svg>
  );
};

// Pricing Actions Icons
export const BackArrowIcon = () => {
  return (
    <svg className='mr-2' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <polyline points='15 18 9 12 15 6'></polyline>
    </svg>
  );
};

export const GeneratePDFIcon = () => {
  return (
    <svg className='mr-2' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
      <polyline points='14 2 14 8 20 8' />
    </svg>
  );
};

export const TriangleUpIcon = ({ onClick }) => {
  return (
    <svg className='triangle-up-button' width='30px' height='30px' viewBox='0 0 256 256' onClick={onClick}>
      <g
        style={{
          stroke: 'none',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'none',
          fillRule: 'nonzero',
          opacity: 1
        }}
        transform='scale(1.5 1.5) translate(40 30)'>
        <path
          d='M 90 82.471 H 0 L 45 4.529 L 90 82.471 z M 9.909 76.75 h 70.182 L 45 15.971 L 9.909 76.75 z'
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fill: '#4461ed',
            fillRule: 'nonzero',
            opacity: 1
          }}
          transform=' matrix(1 0 0 1 0 0) '
          strokeLinecap='round'
        />
      </g>
    </svg>
  );
};
